import { render, staticRenderFns } from "./tact.vue?vue&type=template&id=a654195e&scoped=true&"
import script from "./tact.vue?vue&type=script&lang=js&"
export * from "./tact.vue?vue&type=script&lang=js&"
import style0 from "./tact.vue?vue&type=style&index=0&id=a654195e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a654195e",
  null
  
)

export default component.exports